import React from 'react';

interface IconInfoProps {
    iconClasses?: string;
}

const IconInfo: React.FC<IconInfoProps> = ({ iconClasses }) => {
    return (
        <svg
            aria-hidden="true"
            className={`icon icon-info ${iconClasses ?? ''}`}
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2415_4021)">
                <path
                    d="M12.8346 6.99984C12.8346 10.2215 10.223 12.8332 7.0013 12.8332C3.77964 12.8332 1.16797 10.2215 1.16797 6.99984C1.16797 3.77818 3.77964 1.1665 7.0013 1.1665C10.223 1.1665 12.8346 3.77818 12.8346 6.99984Z"
                    strokeWidth="1.16667"
                    stroke="currentColor"
                />
                <path d="M7 4.6665V6.99984" strokeWidth="1.16667" stroke="currentColor" />
                <path d="M7 9.3335H7.00583" strokeWidth="1.16667" stroke="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_2415_4021">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconInfo;
